module.exports = __webpack_public_path__ + "static/media/lineArrow.4a201396.svg";